var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5386 3.47113C15.2438 3.17629 14.7657 3.17629 14.4709 3.47113L6.4709 11.4711C6.17605 11.766 6.17605 12.244 6.4709 12.5389L14.4709 20.5389C14.7657 20.8337 15.2438 20.8337 15.5386 20.5389C15.8335 20.244 15.8335 19.766 15.5386 19.4711L8.0725 12.005L15.5386 4.53887C15.8335 4.24402 15.8335 3.76598 15.5386 3.47113Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.2ce2c2a4a2031f793c32955326e089e9.svg";
export { ForwardRef as ReactComponent };